export default "__VITE_ASSET__Cp72i0XA__"